module.exports = __webpack_public_path__ + "media/images/flags/vn-2301f6f466f2e744e48a5bbaa83269eb.svg";